// extracted by mini-css-extract-plugin
export default {"title":"details_title__0ztzA","container":"details_container__ngx5N","header":"details_header__YuRFD"};